import { render, staticRenderFns } from "./Answer_intellect_guide.vue?vue&type=template&id=ff71cf84&scoped=true"
import script from "./Answer_intellect_guide.vue?vue&type=script&lang=js"
export * from "./Answer_intellect_guide.vue?vue&type=script&lang=js"
import style0 from "./Answer_intellect_guide.vue?vue&type=style&index=0&id=ff71cf84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff71cf84",
  null
  
)

export default component.exports